import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { selectViewAs, viewAsSet } from '@features/auth/slice';
import type { ViewAsContext } from '@features/auth/types';

interface UseViewAsResult {
  viewAs: ViewAsContext | null;
  setViewAs: (next: ViewAsContext | null) => void;
  clearViewAs: () => void;
  isViewingAsMerchant: boolean;
  isViewingAsVendor: boolean;
}

export function useViewAs(): UseViewAsResult {
  const dispatch = useDispatch();
  const viewAs = useSelector(selectViewAs);

  const setViewAs = useCallback(
    (next: ViewAsContext | null) => {
      dispatch(viewAsSet(next));
    },
    [dispatch],
  );

  const clearViewAs = useCallback(() => {
    dispatch(viewAsSet(null));
  }, [dispatch]);

  return {
    viewAs,
    setViewAs,
    clearViewAs,
    isViewingAsMerchant:
      viewAs?.userType === 'merchant' || viewAs?.userType === 'parent-merchant',
    isViewingAsVendor:
      viewAs?.userType === 'vendor' || viewAs?.userType === 'facility',
  };
}
